import { render, staticRenderFns } from "./dialogHeader.vue?vue&type=template&id=6e5ecb17&"
import script from "./dialogHeader.vue?vue&type=script&lang=js&"
export * from "./dialogHeader.vue?vue&type=script&lang=js&"
import style0 from "./dialogHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "dialogHeader.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VFlex,
  VIcon,
})
